import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environment';
import { Organisation } from '../models/organisation.model';
import { normalizeApiArray } from '../utils/api-response.util';

@Injectable({
  providedIn: 'root'
})
export class OrganisationService {
  private apiUrl = `${environment.apiUrl}/Organisation`;

  constructor(private http: HttpClient) { }

  getOrganisations(): Observable<Organisation[]> {
    return this.http.get<unknown>(this.apiUrl).pipe(
      map(response => normalizeApiArray<Organisation>(response))
    );
  }

  getOrganisation(id: number): Observable<Organisation> {
    return this.http.get<Organisation>(`${this.apiUrl}/${id}`);
  }

  createOrganisation(organisation: Partial<Organisation>): Observable<Organisation> {
    return this.http.post<Organisation>(this.apiUrl, organisation);
  }

  updateOrganisation(id: number, organisation: Partial<Organisation>): Observable<Organisation> {
    return this.http.put<Organisation>(`${this.apiUrl}/${id}`, organisation);
  }

  deleteOrganisation(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`);
  }

  getOrganisationUsers(id: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/${id}/users`);
  }

  getOrganisationVehicles(id: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/${id}/vehicles`);
  }

  getOrganisationTrips(id: number, filters?: any): Observable<any[]> {
    let params: any = {};
    if (filters) {
      params = { ...filters };
    }
    return this.http.get<any[]>(`${this.apiUrl}/${id}/trips`, { params });
  }

  getOrganisationStats(id: number): Observable<{
    totalVehicles: number;
    activeTrips: number;
    totalBookings: number;
    monthlyRevenue: number;
  }> {
    return this.http.get<any>(`${this.apiUrl}/${id}/stats`);
  }
}
